import React, { useState } from 'react';
import { components as Core, useTranslation } from '../../../../core';
import { common, css, marginsRight, paddings } from '../../../../../styles';

/**
 * Asks whether a customer should be notified before executing a blocking action.
 *
 * @param {object} props
 * @param {boolean} props.isLoading
 * @param {string} props.label
 * @param {Function|null} props.onPress
 */
export const ButtonWithPopover = ({ isLoading = false, label, onPress = null }) => {
    const { t } = useTranslation();
    const [isVisiblePopup, setIsVisiblePopup] = useState(false);

    const togglePopover = () => setIsVisiblePopup(previousValue => !previousValue);
    const handlePress = value => () => {
        onPress(value);
        setIsVisiblePopup(false);
    };

    const content = (
        <div className={css([common.flexRowEnd, paddings.s3])}>
            <Core.Button
                onPress={handlePress(true)}
                label={t('integrations.notifyAboutBlocking')}
                className={marginsRight.s2}
            />
            <Core.Button
                onPress={handlePress(false)}
                label={t('integrations.skipNotifyAboutBlocking')}
            />
        </div>
    );

    return (
        <Core.Popover
            content={content}
            visible={isVisiblePopup}
            onVisibleChange={setIsVisiblePopup}>
            <span>
                <Core.Button label={label} onPress={togglePopover} isLoading={isLoading} />
            </span>
        </Core.Popover>
    );
};
